import React from 'react';

/**
 * South African Rand (R) Icon matching Feather icon standards
 * Used across financial tabs and badges (e.g. Client Holdings)
 */
export const RandIcon = ({ 
  className = "w-3.5 h-3.5", 
  size, 
  strokeWidth = 2,
  ...props 
}) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth={strokeWidth}
    viewBox="0 0 24 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    height={size || "1em"}
    width={size || "1em"}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path d="M6 4h7a5 5 0 0 1 0 10H6" />
    <line x1="6" y1="4" x2="6" y2="20" />
    <line x1="13" y1="14" x2="19" y2="20" />
  </svg>
);

export default RandIcon;
